// Mi6 AIP version constants — single source of truth.
// Canon §22 (Version control) requires every display surface to import from here.
// Never hardcode a version string elsewhere in client code.
//
// Format: v{major}.{minor}.{YYYY-MM-DD}
// - Minor bump: canon change, schema migration, new role view, scoring math change.
// - Patch (date roll only): bug fix that doesn't touch canon.
// - Major bump: architectural rewrite, methodology engine change, tenant model change.

export const AIP_VERSION = "v3.17.2026-06-10";
export const AIP_VERSION_NOTE =
  "Pilot-tenant partner purge. All partner-cohort user accounts, owned accounts, prospects, FK descendants, auth records, and feature-flagged pilot/BDR-discovery routes removed. Names sanitized to Demo placeholders across seed, tour, and UI surfaces. Tenant 1 retained for next client (Frank's 10 placeholder accounts intact).";

// Spec version moves in lockstep with the platform version.
export const AIP_SPEC_VERSION = AIP_VERSION;

// Question bank version is independent and bumps on its own cadence.
export const AIP_QUESTION_BANK_VERSION = "v1.0";
